export const PROPERTY_CATEGORY_LANDED = 'landed';
export const PROPERTY_CATEGORY_HIGH_RISE = 'high_rise';



// WEBPACK FOOTER //
// ./src/constants/propertyCategories.js